import React from 'react';

import SCIsRent from '../../components/Prospecting/SCIsRent/SCIsRent.module';

function SCIsRentView() {
  return (
    <SCIsRent />
  );
}

export default SCIsRentView;


